export default __webpack_public_path__ + "static/media/connecterror-placeholder.3d42865f.svg";